import type { LeftnavStorageNotificationProps } from "./components/LeftnavStorageNotification";
import type * as lazyIndex from "./lazyIndex";
import { createLazyComponent, type LazyComponent, LazyModule } from "owa-bundling";

const lazyModule: LazyModule<typeof lazyIndex> = new LazyModule(() => import(/* webpackChunkName: "LeftNavUpsell" */ "./lazyIndex"), { name: "LeftNavUpsell" });

export const LeftnavStorageNotification: LazyComponent<LeftnavStorageNotificationProps, unknown, void> = createLazyComponent(lazyModule, m => m.LeftnavStorageNotification);
